module.exports = require("@open-rpc/client-js/build/transports/Transport");